import React from 'react';
import { Container } from 'reactstrap';
import packageJson from '../../package.json';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="app-footer border-top bg-light text-muted py-2 mt-auto">
            <Container fluid className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-1 small">
                <span>OnSight Customer Web Portal</span>
                <span>Version {packageJson.version}</span>
                <span>&copy; {currentYear} National Presort</span>
            </Container>
        </footer>
    );
}